import * as Card from './card.styled'

export default Card
